import React, { useCallback, useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space } from 'antd';

import AddEditRegionModal from '@totem/components/portfolio/regions/AddEditRegionModal';
import RegionsContext from '@totem/components/portfolio/regions/list/RegionsContext';
import RegionsTable from '@totem/components/portfolio/regions/list/RegionsTable';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import colors from '@totem/styles/colors';
import { debounce } from '@totem/utilities/debounce';

const DEBOUNCE_TIME = 300;

const styles = {
  icon: {
    color: colors.neutral.gray,
  },
};

export const RegionsExtra = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { totalRecords, onAction } = useContext(RegionsContext);

  const canManage =
    permissions.organizationalAdministrator.hasPermissions(userProfile);

  return (
    <Space>
      <RecordCountBadge count={totalRecords} />
      {canManage && (
        <Button type="primary" onClick={() => onAction('add')}>
          Add Region
        </Button>
      )}
    </Space>
  );
};

const RegionsLayout = () => {
  const {
    searchTerm,
    setSearchTerm,
    isModalOpen,
    isEdit,
    editingRegion,
    sending,
    onSubmit,
    onCloseModal,
  } = useContext(RegionsContext);

  const handleSearch = useCallback(
    debounce((term: string) => setSearchTerm(term), DEBOUNCE_TIME),
    [],
  );

  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <Input
          placeholder="Search Region"
          prefix={<SearchOutlined style={styles.icon} />}
          defaultValue={searchTerm}
          onChange={(event) => handleSearch(event.target.value)}
          style={{ maxWidth: '20rem' }}
        />
      </div>
      <RegionsTable />
      <AddEditRegionModal
        open={isModalOpen}
        isEdit={isEdit}
        region={editingRegion}
        loading={sending}
        onCancel={onCloseModal}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default RegionsLayout;
